
  export default {
    props: {
      tabs: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        selectedTab: ''
      };
    },
    created () {
      this.selectedTab = Object.keys(this.tabs)[0];
    },
    methods: {
      clickedTab (key) {
        this.selectedTab = key;
        this.$emit('changed', key);
      }
    }
  };
